import React from "react";

import cx from "classnames";

import { TabIndexVisibility } from "../TabIndexVisibility";

import styles from "./SlideIntoView.scss";

/**
 * The `SlideIntoView` component provides a way to smoothly slide content into
 * view based on the `open` prop.
 */
export function SlideIntoView({
  children,
  open,
  ...divProps
}: React.PropsWithChildren<SlideIntoViewProps> &
  Omit<React.HTMLAttributes<HTMLDivElement>, "className">) {
  const className = cx(divProps.className, styles.slideIntoView, {
    [styles.open]: Boolean(open),
  });
  return (
    <div {...divProps} className={className}>
      <TabIndexVisibility visible={Boolean(open)}>
        {children}
      </TabIndexVisibility>
    </div>
  );
}

export interface SlideIntoViewProps {
  /**
   * Controls whether the component is open or closed.
   */
  open: boolean;
  /**
   * Additional CSS class names to apply to the component.
   */
  className?: string;
}
